import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-order-success',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './order-success.component.html',
  styleUrl: './order-success.component.scss'
})
export class OrderSuccessComponent {


  @Output() close=new EventEmitter<any>();
  @Output() viewHistory=new EventEmitter<any>();

  closePopup(type:any){
    this.close.emit(type);
  }
}
